module.exports = __webpack_public_path__ + "static/media/SDFSA_5-509w.50d7c1a2.webp";